import { render, staticRenderFns } from "./PPDS.vue?vue&type=template&id=49599da3&scoped=true&"
import script from "./PPDS.vue?vue&type=script&lang=js&"
export * from "./PPDS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49599da3",
  null
  
)

export default component.exports